module.exports = __webpack_public_path__ + "77b15aa95cc0680360a3276556aa70cb.jpg";